import { CoachingCultureTheme, getDefaultTheme } from "@coaching-culture/ui";

// Inter for UI text (better small-size rendering than Montserrat), with
// Montserrat kept for headings.
const getTheme = (): CoachingCultureTheme => {
  const theme = getDefaultTheme();

  return {
    ...theme,
    fonts: {
      ...theme.fonts,
      body: "'Inter', 'Segoe UI', system-ui, -apple-system, sans-serif",
      heading: "'Montserrat', 'Inter', 'Segoe UI', sans-serif",
    },
  };
};

export default getTheme;
